import { render, staticRenderFns } from "./CustomerForm4473.vue?vue&type=template&id=05af11c2&scoped=true"
import script from "./CustomerForm4473.vue?vue&type=script&lang=js"
export * from "./CustomerForm4473.vue?vue&type=script&lang=js"
import style0 from "./CustomerForm4473.vue?vue&type=style&index=0&id=05af11c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05af11c2",
  null
  
)

export default component.exports